<template>
   <div class="crud-wrapper">
      <crud :filterBy="{filters: dataFilter, isAffiliate: true, isMaster: isMaster()}" :form-component="CampaignForm" :grid-columns="gridColumns" :grid-options="gridOptions"
            obj="campaign" ref="crud">
      </crud>
   </div>
</template>

<script>

   import PageClass from '@consigmais-team/vue-common/layout/defaultPage/pageClass';
   import CampaignForm from './CampaignForm';
   import numeral from 'numeral';

   export default PageClass.extend({
      name: 'Campaigns',

      data () {
         return {
            CampaignForm,

            gridColumns: [
               {
                  dataField: 'title',
                  caption: 'Campanha',
                  minWidth: 150
               },
               {
                  dataField: 'slug',
                  caption: 'Código',
                  width: 100,
               },
               {
                  dataField: 'productLink',
                  caption: 'Link do produto',
                  minWidth: 300,
               },
               {
                  dataField: 'createdAt',
                  caption: 'Criado em',
                  dataType: 'date',
                  format: 'dd/MM/yyyy HH:mm',
                  width: 150,
               },
               {
                  dataField: 'leads',
                  caption: 'Leads',
                  width: 70,
               },
               {
                  dataField: 'amountSum',
                  caption: 'Produção',
                  dataType: 'number',
                  width: 120,
                  format: function (value) { 
                     return numeral(value).format('0,0.' + '0'.repeat(2)); 
                  }
               },
               {
                  dataField: 'affiliateCommissionSum',
                  caption: 'Comissão',
                  dataType: 'number',
                  width: 120,
                  format: function (value) {
                     return numeral(value).format('0,0.' + '0'.repeat(2));
                  }
               },
               {
                  name: 'productLink',
                  width: 100,
                  alignment: 'left',
                  cellTemplate: (element, info) => {
                     let data = {};

                     $(`<button>Copiar link</button>`).on('dxclick', data, (event) => { event.stopPropagation(); this.copyLink(info.data.productLink); }).appendTo(element);
                  }
               },
               ...this.isMaster() == true ? [{
                   dataField: 'affiliateName',
                   caption: 'Afiliado',
                   minWidth: 150
               }] : [],
            ],
            gridOptions: {
               
            },
            dataFilter: {}
         };

      },

		   methods: {
            isMaster () {
               return this.$uCan({ key: 'subAfiliados' }) === 1;
            },

            copyLink(link) {
               window.Clipboard.copy(link);
               this.$notifyUser({
                  message: 'Texto Copiado!'
               });
            },

            pageFiltersChange (filters) {
                this.dataFilter = {
                    beginDate: filters.dateRange && filters.dateRange[0] ? filters.dateRange[0] : null,
                    endDate: filters.dateRange && filters.dateRange[1] ? filters.dateRange[1] : null,
                    affiliateId: filters.affiliateId ? filters.affiliateId : null,
                };
            },

            async init(){
               console.log(this.hasPageFilters,'this.hasPageFilters')
               if (!this.hasPageFilters) {
                    this.createPageFilters([
                        { field: 'dateRange' },
                        { field: 'affiliateId' },
                    ]);

                    let endDate = this.$moment().format('YYYY-MM-DD');
                    let beginDate = this.$moment().format('YYYY-MM-01');
                    this.setPageFilter(
                        'dateRange', 
                        [
                            beginDate, endDate
                        ],
                        'Entre {0} e {1}'.format(this.$moment(beginDate).format('DD/MM/YYYY'), this.$moment(endDate).format('DD/MM/YYYY'))
                    );
                }else {

                    let filters = this.$store.getters.activePageFilters;
                    this.dataFilter = {
                        beginDate: filters.dateRange && filters.dateRange[0] ? filters.dateRange[0] : null,
                        endDate: filters.dateRange && filters.dateRange[1] ? filters.dateRange[1] : null,
                        affiliateId: filters.affiliateId || null,
                    };

                }
            }
		   },

         created () {
            this.init();
         }
   	});
      

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Campaigns.vue